import { Component, OnInit, inject } from '@angular/core';
import { MobileViewService } from 'src/app/services/mobile-view.service';

import { TranslocoModule } from '@jsverse/transloco';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { RouterModule } from '@angular/router';
import { JwtService } from 'src/app/services/jwt.service';
import { BackendService } from 'src/app/services/backend.service';
import { DecodedJwt } from 'src/app/services/token.interface';
import { CapabilityCheckPipe } from 'src/app/pipes/check-capability.pipe';
import { HrCapabilityCheckPipe } from 'src/app/pipes/hr-capability-check.pipe';
import { HrAuthService } from 'src/app/services/hr-auth.service';
import { HrFeaturesService } from 'src/app/services/hr-features.service';
import { TimeTrackingAvailabilityService } from 'src/app/views/personnel/time-tracking/time-tracking-availability.service';
import { HrSessionService } from 'src/app/services/hr-session.service';
import { UserSessionService } from 'src/app/services/user-session.service';
import { YardClaimOutboxService } from 'src/app/views/yard/services/yard-claim-outbox.service';
import { storageKey } from 'src/app/shared/utils/storage.util';

@Component({
    selector: 'app-user-avatar',
    templateUrl: './user-avatar.component.html',
    styleUrls: ['./user-avatar.component.scss'],
    imports: [
        TranslocoModule,
        MatMenuModule,
        MatButtonModule,
        RouterModule,
        MatIconModule,
        MatBadgeModule,
        CapabilityCheckPipe,
        HrCapabilityCheckPipe
    ]
})
export class UserAvatarComponent implements OnInit {
  userLogin: DecodedJwt;
  userName = '';
  mobile: boolean;
  version = localStorage.getItem(storageKey('app_version'));

  /** Phase 2: shows pending offline claims; Phase 1 stub returns 0 (badge hidden). */
  readonly outbox = inject(YardClaimOutboxService);
  protected readonly hrFeatures = inject(HrFeaturesService);
  /** Time tracking runs through ShipSolution, so it needs no Caresonal login */
  protected readonly timeTracking = inject(TimeTrackingAvailabilityService);

  constructor(
    private readonly jwtService: JwtService,
    private readonly backendService: BackendService,
    private readonly mobileService: MobileViewService,
    private readonly hrAuthService: HrAuthService,
    private readonly hrSessionService: HrSessionService,
    private readonly userSessionService: UserSessionService
  ) {}

  ngOnInit(): void {
    this.mobile = this.mobileService.detectMobileDevice();
    this.timeTracking.refresh();
    this.userLogin = this.jwtService.userData;
    this.jwtService.$loginChange.subscribe((loggedIn) => {
      this.userLogin = loggedIn ? this.jwtService.userData : null;
    });
    this.userSessionService.profile$.subscribe(() => {
      this.userName = this.userSessionService.name;
    });
  }

  onLogoutClicked(): void {
    this.backendService.logout().subscribe({
      complete: () => this.hrSessionService.clearSession()
    });
  }

  get roleId() {
    return this.userLogin?.role.id;
  }

  get hasLinkedPersonnel(): boolean {
    return this.hrAuthService.hasLinkedPersonnel();
  }
}
